import { MapStyle } from 'root/model/map/MapEnums';

export const scaleOptions = {
    [MapStyle.OS_EXPLORER]: 'OS Explorer, 1:25 000',
    [MapStyle.OS_LANDRANGER]: 'OS Landranger, 1:50 000',
};
